import { Component, h } from '@stencil/core';

@Component({
  tag: 'signet-h5',
  styleUrl: 'signet-h5.scss',
  shadow: true,
})
export class SignetH5 {
  render() {
    return <h5><slot /></h5>;
  }
}
